export const LIST_MODE = {
  ALL: "all",
  SELECT: "select",
  PAGINATED: "paginated",
};

export const LIST_PER_PAGE = 10;
